import React from 'react';
import { Modal, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import './WarningModal.css';

const WarningModal = ({
  open,
  onClose,
  title,
  children,
  buttonText,
  secondaryButtonText,
  onSecondaryClick,
  onConfirm,
  confirmText,
  cancelText,
  danger = false,
  confirmDisabled = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();

  const resolvedButtonText = buttonText ?? t('warning_got_it');
  const resolvedCancelText = cancelText ?? t('cancel');

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
          padding: isMobile ? '18px 16px' : '26px 22px',
          width: isMobile ? '85%' : '90%',
          maxWidth: 460,
        }}
      >
        <div className="warning-modal-icon">
          <FontAwesomeIcon icon={faTriangleExclamation} />
        </div>
        {title && <h2 className="warning-modal-title">{title}</h2>}
        <div className="warning-modal-body">{children}</div>
        <div className={`warning-modal-actions${onConfirm ? ' confirm' : ''}`}>
          {onConfirm ? (
            <>
              <button
                className="warning-modal-btn secondary"
                onClick={onClose}
                type="button"
              >
                {resolvedCancelText}
              </button>
              <button
                className={`warning-modal-btn${danger ? ' danger' : ''}`}
                onClick={onConfirm}
                disabled={confirmDisabled}
                type="button"
              >
                {confirmText || resolvedButtonText}
              </button>
            </>
          ) : (
            <>
              {secondaryButtonText && (
                <button className="warning-modal-btn secondary" onClick={onSecondaryClick}>
                  {secondaryButtonText}
                </button>
              )}
              <button className="warning-modal-btn" onClick={onClose}>
                {resolvedButtonText}
              </button>
            </>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default WarningModal;
